import React from 'react';
import ApiSecret from './ApiSecret';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../../organisation/feature/helper';
import { useMe } from '../../organisation/useMe';
import SalvPage from '../../common/SalvPage';

const ApiConfiguration = () => {
  const { features } = useMe();

  const monitoringEnabled = isFeatureEnabled(ORGANISATION_FEATURE.MONITORING, features);
  const screeningEnabled = isFeatureEnabled(ORGANISATION_FEATURE.SANCTIONS, features);

  return (
    <SalvPage
      title='API configuration'
      subTitle='Client credentials for authenticating to the Salv public API. Secrets are shown once, at creation.'
    >
      {(monitoringEnabled || screeningEnabled) && <ApiSecret />}
    </SalvPage>
  );
};

export default ApiConfiguration;
